module.exports = __webpack_public_path__ + "assets/img/bl.ef14deed.png";